import React, { Children } from 'react';
import { Box } from '@mui/material';
import SelectedChipFiltersWithAdd from './SelectedChipFiltersWithAdd';
import useChipFilterLayout, { ChipFilter, ChipFilterInputWrapperProps } from './useChipFilterLayout';
import { useUiTheme } from 'framework/uiTheme';
import { Button } from '../../../../ui/mui-builder/Button/Button';
import { SideDrawer } from 'framework/ui/mui-builder';

const ChipFilterLayout = ({
  children,
  defaultFilter,
  additionalButtons = [],
}: {
  children: React.ReactElement<ChipFilterInputWrapperProps>[] | React.ReactElement<ChipFilterInputWrapperProps>;
  defaultFilter: ChipFilter;
  additionalButtons?: React.ReactNode | React.ReactNode[];
}) => {
  const {
    isMenuOpen,
    filterState,
    appliedFilters,
    handleApply,
    handleRemoveFilter,
    handleStrictToggle,
    setFiltersStatesByKey,
    toggleMenu,
    updateFilters,
    handleClickAwayMenu,
  } = useChipFilterLayout({
    defaultFilter,
  });
  const { Button: ThemedButton = Button } = useUiTheme();

  const filtersConfig = Children.map(children, child => {
    if (React.isValidElement(child)) {
      return {
        key: (child.props as any)?.source,
        ...(child.props || {}),
        FilterElement: child,
      };
    }
    return null;
  }).filter(Boolean);

  const drawerContent = (
    <Box>
      {filtersConfig.map(({ key, source, FilterElement, mapValueForChange }: any) => {
        return React.cloneElement(FilterElement, {
          key,
          ...FilterElement.props,
          allSelectedData: filterState,
          value: filterState[source],
          'data-testid': `child-${source}`,
          onChangeCallback: (value: any) => {
            const newValue = mapValueForChange ? mapValueForChange(value, filterState) : value;
            updateFilters(source, newValue);
          },
        });
      })}
    </Box>
  );

  return (
    <Box>
      <SelectedChipFiltersWithAdd
        toggleMenu={toggleMenu}
        appliedFilters={appliedFilters}
        handleRemoveFilter={handleRemoveFilter}
        setFiltersStatesByKey={setFiltersStatesByKey}
        handleStrictToggle={handleStrictToggle}
        filtersConfig={filtersConfig.map(({ FilterElement: _, ...item }) => ({ ...item }))}
        additionalButtons={additionalButtons}
        data-testid-prefix="chipfilter"
      />

      <SideDrawer
        isOpen={isMenuOpen}
        onClose={handleClickAwayMenu}
        title="Filters"
        width={420}
        content={drawerContent}
        actions={{
          type: 'custom',
          content: (
            <Box sx={{ mt: 2 }}>
              <ThemedButton data-testid="apply-button" sx={{ padding: 0 }} variant="contained" onClick={handleApply}>
                Apply
              </ThemedButton>
            </Box>
          ),
        }}
      />
    </Box>
  );
};

export default ChipFilterLayout;
